import { Button, InputLabel, TextField } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLogin } from "../redux/items/LoginReducer";
import { setLoadingPage } from "../redux/items/PageLoading";
import { parseInt2 } from "../utils/functions";
import FetchLogin from "./Fetch/FetchLogin";

let depositPusherInstance;

const PayNowAutoCredit = () => {
	const token = useSelector((state) => state.login.token);
	const dispatch = useDispatch();
	const loginUser = useSelector((state) => state.login?.user);
	const login = useSelector((state) => state?.login);

	const [v, setV] = useState({
		amount: 0,
		success: true,
		qrcode: "",
		error: "",
		timer: 0,
	});

	useEffect(() => {
		let timer;
		if (localStorage.getItem("paynow_timer")) {
			timer = setInterval(() => {
				let countdown = localStorage.getItem("paynow_timer");
				if (countdown >= 0) {
					setV2({ timer: countdown });
				} else {
					clearInterval(timer);
				}
			}, 1e3);
		}
		// eslint-disable-next-line
	}, [null, localStorage.getItem("paynow_timer")]);

	const reqGenLion = FetchLogin("/gen-lion", {
		baseUrl: "https://api.lioncitytransport.com/api",
		data: {
			amount: v.amount,
			token: token,
		},
		callbackInit: () => {
			setV2({ success: true, qrcode: "", error: "" });
			dispatch(setLoadingPage(true));
		},
		callback: (cb) => {
			if (cb.response.success) {
				setV2({
					success: cb.response.success,
					error: cb.response.message,
					qrcode: cb.response.data.qrcode,
				});
				localStorage.setItem("paynow_timer", 30);
				dispatch(setLoadingPage(false));
			} else {
				setV2({
					success: cb.response.success,
					error: cb.response.message,
				});
			}
		},
	});

	const reqFneCharge = FetchLogin("/charge", {
		baseUrl: "https://app.fnelogistics.com/api",
		data: {
			amount: v.amount,
			token: token,
		},
		callbackInit: () => {
			setV2({ success: true, qrcode: "", error: "" });
			dispatch(setLoadingPage(true));
		},
		callback: (cb) => {
			if (cb.response.success) {
				setV2({
					success: cb.response.success,
					error: cb.response.message,
					qrcode: cb.response.data.qrcode,
				});
				localStorage.setItem("paynow_timer", 30);
				dispatch(setLoadingPage(false));
			} else {
				setV2({
					success: cb.response.success,
					error: cb.response.message,
				});
			}
		},
	});

	const reqGenerate = FetchLogin("/generateqr", {
		// baseUrl: "https://thepremiumapi.com",
		data: {
			amount: v.amount,
			//   token: "yfphzxf4mt3arewlsafhlgy65c2jzn",
			token: token,
			web: document.location.origin,
		},
		callbackInit: () => {
			setV2({ success: true, qrcode: "", error: "" });
			dispatch(setLoadingPage(true));
		},
		callback: (cb) => {
			if (cb.response.success) {
				let d = 1;
				if (cb.response.data.action !== undefined) {
					if (cb.response.data.action === "redirect") {
						if (cb.response.data.id === 3) {
							d = 0;
							reqGenLion.handleTrigger();
						} else if (cb.response.data.id === 4) {
							d = 0;
							reqFneCharge.handleTrigger();
						}
					}
				}

				if (d) {
					setV2({
						success: cb.response.success,
						error: cb.response.message,
						qrcode: cb.response.data.qrcode,
					});
					localStorage.setItem("paynow_timer", 30);
					dispatch(setLoadingPage(false));
				}
			} else {
				setV2({
					success: cb.response.success,
					error: cb.response.message,
				});
			}
		},
	});

	const setV2 = (v2) => {
		setV((prev) => ({ ...prev, ...v2 }));
	};

	useEffect(() => {
		if (token) {
			// Use reactive reference
			// You need to import Pusher or define it globally
			// Add this import at the top
			depositPusherInstance = new window.Pusher("fd72fcb329c65bcfdbce", {
				cluster: "ap1",
				authEndpoint: process.env.REACT_APP_BASE_URL_API + "/auth",
			});
			depositPusherInstance.connection.bind("connected", function () {
				let channel = depositPusherInstance.subscribe("private-my-channel");
				channel.bind("qr." + loginUser.contact_no, function (data) {
					dispatch(
						setLogin({
							...login,
							user: { ...loginUser, credits: data.amount },
						})
					);
					setV2({ amount: 0, success: true, qrcode: "", error: "", timer: 0 });
				});
			});
		}

		return () => {
			if (!token) {
				if (depositPusherInstance) {
					depositPusherInstance.disconnect();
				}
			}
		};
		// eslint-disable-next-line
	}, [token]);

	return (
		<>
			{v.qrcode === "" && (
				<>
					<div
						style={{
							display: "flex",
							flexDirection: "row",
							justifyContent: "center",
							alignItems: "center",
							margin: "0 auto",
							marginTop: 20,
							width: "90%",
						}}
					>
						<InputLabel
							htmlFor="amount"
							style={{
								fontWeight: "bold",
								fontSize: 20,
								width: "100%",
								marginTop: -32,
							}}
						>
							Amount to Top Up
						</InputLabel>
						<div style={{ width: "100%" }}>
							<TextField
								variant="outlined"
								id="amount"
								value={v.amount === 0 ? "" : v.amount}
								onChange={(e) => setV2({ amount: parseInt2(e.target.value) })}
							/>
							<p
								style={{
									marginTop: 0,
									color: "#aaa",
									fontStyle: "italic",
								}}
							>
								Minimum of SGD 10
							</p>
						</div>
					</div>
					<div style={{ textAlign: "center", marginTop: 20 }}>
						<Button
							onClick={() => reqGenerate.handleTrigger()}
							disabled={v.timer > 0}
						>
							Generate QR Code
							{v.timer > 0 ? (
								<>
									<br /> Please Wait {v.timer}s
								</>
							) : null}
						</Button>
					</div>
					<div
						style={{
							color: v.success ? "green" : "red",
							textAlign: "center",
							marginTop: 20,
						}}
					>
						{v.error}
					</div>
				</>
			)}
			{v.qrcode !== "" && (
				<div style={{ textAlign: "center" }}>
					<Button size="small" onClick={() => setV2({ qrcode: "", error: "" })}>
						Top Up More
						{v.timer > 0 ? (
							<>
								<br /> Please Wait {v.timer}s
							</>
						) : null}
					</Button>
					<br />
					<br />
					<span
						style={{
							position:
								process.env.REACT_APP_YES_APP === undefined
									? "absolute"
									: "relative",
							zIndex: 1,
							fontWeight: "bold",
							fontSize: 26,
							width: "100%",
							left: 0,
						}}
					>
						Top Up SGD {v.amount}
					</span>
					<img
						className="qr-image"
						src={v.qrcode}
						width="100%"
						alt="Qr Code"
						style={
							process.env.REACT_APP_YES_APP === undefined
								? {
										width: "calc(100% + 72px)",
										left: "calc((50% + 32px) * -1)",
										position: "relative",
										marginLeft: "50%",
								  }
								: {
										width: "100%",
								  }
						}
					/>
					<p
						style={{
							margin: 0,
							color: "#444",
							fontStyle: "italic",
							fontSize: 20,
							position:
								process.env.REACT_APP_YES_APP === undefined
									? "absolute"
									: "relative",
							marginTop: 0,
							// background: "red",
							width: "100%",
							left: 0,
						}}
					>
						One-Time Use Only
					</p>
					<h3
						style={{
							margin: 0,
							textAlign: "left",
							textIndent: 0,
							marginBottom: 10,
							marginTop: 58,
						}}
					>
						How to Pay via PayNow
					</h3>
					<ol
						className="numbered-list"
						style={{ width: "90%", margin: "0 auto", textAlign: "left" }}
					>
						<li>Save or screenshot the QR code image.</li>
						<li>Launch and login to your PayNow supporting banking app.</li>
						<li>Choose "Scan & Pay"</li>
						<li>
							Use "Scan & Pay" or "Pay with QR Code" to scan or upload this QR
							code <b>only once</b>.
						</li>
						<li>Complete the payment.</li>
					</ol>
					<h4
						style={{
							margin: 0,
							textAlign: "left",
							textIndent: 0,
							marginBottom: 10,
							marginTop: 50,
							fontSize: 18,
						}}
					>
						Support Banking App
					</h4>
					<p style={{ textAlign: "left", marginLeft: 0, fontSize: 16 }}>
						You can use PayNow supporting banking apps to complete the payment,
						such as DBS PayLah!, DBS/POSB Digibank, OCBC PayAnyone, UOB Tmrw,
						Citibank SG, HSBC Singapore.
					</p>
				</div>
			)}
		</>
	);
};

export default PayNowAutoCredit;
